<div class="fluid">
  <div class="field grid col-12">
    <label for="DN1">{{sNoteLable}}</label>
    <input id="DN1" type="text" pInputText [(ngModel)]="newDocument.DOCNOTE1" value="newDocument.DOCNOTE1" />
  </div>
  <div class="field grid col-12">
    <label for="DN2">{{bNoteLable}}</label>
    <input id="DN2" type="text" pInputText [(ngModel)]="newDocument.DOCNOTE2" value="newDocument.DOCNOTE1" />
  </div>
</div>
